/* eslint-disable react/no-array-index-key */
import React from 'react';

function PageMeta({
    title = null,
    image = null,
}: {
    title?: string | null;
    image?: string | null;
}) {
    return (
        <>
            {title !== null ? <title>{title}</title> : null}
            {image !== null ? <meta property="og:image" content={image} /> : null}
        </>
    );
}

export default PageMeta;
